// extracted by mini-css-extract-plugin
export default {"top_div":"TermsScreen_top_div__+ecAx"};